import { clsx } from 'clsx';

interface AuthorizedPaymentInfoCardProps {
  chainStoreName: string;
  amount: string;
  transactionTypeI18n: string;
}

export const AuthorizedPaymentInfoCard = ({
  chainStoreName,
  amount,
  transactionTypeI18n,
}: AuthorizedPaymentInfoCardProps) => {
  return (
    <div
      className={clsx(
        'flex',
        'flex-col',
        'items-stretch',
        'px-6',
        'pt-16',
        'pb-8',
        'rounded-[10px]',
        'shadow-[0_4px_16px_rgba(0,0,0,0.12)]',
        'bg-white',
        'relative',
      )}
    >
      <div
        className={clsx(
          'w-[100px]',
          'h-[100px]',
          'bg-no-repeat',
          'bg-center',
          'bg-contain',
          'border-[white]',
          'border-[4px]',
          'overflow-hidden',
          'rounded-full',
          'absolute',
          'top-0',
          'left-1/2',
          'transform',
          '-translate-x-1/2',
          '-translate-y-1/2',
        )}
        style={{
          backgroundImage: `url("../assets/img-chainstore.svg")`,
        }}
      />
      <span className="text-center">{chainStoreName}</span>
      <h2 className="text-center text-[24px] font-extrabold mt-1.5">
        同意麻吉雲預授權扣款
      </h2>
      <span className="text-[24px] self-center text-[#00D7B2] mt-4">
        {`${Math.round(+amount).toLocaleString()} 元`}
      </span>

      <hr className="border-[1px] border-dashed w-full my-4" />
      <span className="text-[#555555] text-[14px]">
        同意預授權將產生一筆過卡交易，實際請款依最後
        {transactionTypeI18n}服務費用為準，請安心。
      </span>
    </div>
  );
};
